import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';
import { Bubbles } from './Bubbles';
import { styles } from './Content.scss';

const cx = classNames.bind(styles);

export const Content = ({ children }) => (
  <div className={cx('l-homepage-hero-content')}>
    <div className="l-homepage-hero-content__wrapper">
      <div className="l-homepage-hero-content__inner">
        <div className="l-homepage-hero-content__main">
          <Text
            size={{
              xlarge: '3xl',
              large: 'lg',
              medium: '3xl',
              xsmall: 'lg',
            }}
            fontFamily="serif"
            fontWeight="semibold"
            color="theme-white"
            marginBottom="large"
            className="u-margin-bottom-xlarge-stretched@xlarge">
            Find your dream home before it hits the market.
          </Text>
          <div className="l-homepage-hero-content__searchbar">{children}</div>
        </div>
        <div className="l-homepage-hero-content__media">
          <Bubbles />
        </div>
      </div>
    </div>
  </div>
);

Content.propTypes = {
  children: PropTypes.any,
};
